exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo{margin:auto;max-width:250px}.bg{background-image:url(\"/background.png\");background-size:cover;background-color:#00482b}#inspire{background:none}.footer-bg{color:#fff!important;background-color:transparent!important}", ""]);

// exports
